import { useCheckbox, useCheckboxGroup } from '@chakra-ui/react'
import { Box, Center, HStack } from 'front-end/src/components'
import React, { useEffect } from 'react'
import { useLooopTheme } from '../../../../public-api/hooks/useLooopTheme'
import { brandColors } from 'shared/basicPalette'
import { EventRecurrenceDayEnum } from '../../../../graphql/private/PrivateSchemaTypes'
import {
  getDayIndexes,
  getDayShortcut,
  getDayValuesByIndex,
  getProperLocaleWeek
} from 'front-end/src/pages/manage-events/eventUtils'

export type DaySelectorProps = {
  onChange: (params: EventRecurrenceDayEnum[]) => void
  defaultValue: EventRecurrenceDayEnum[]
  dataTest?: string
}

export const DaySelector = ({
  onChange,
  defaultValue = [EventRecurrenceDayEnum.SA],
  dataTest = 'DaySelector'
}: DaySelectorProps) => {
  const options = getProperLocaleWeek()

  const setResult = (values: EventRecurrenceDayEnum[]) => {
    const indexes = getDayIndexes(values).sort()
    const value = getDayValuesByIndex(indexes)
    onChange(value)
  }

  useEffect(() => {
    setResult(defaultValue)
  }, [])

  const { getCheckboxProps, setValue } = useCheckboxGroup({
    defaultValue: defaultValue,
    onChange: (values) => {
      if (values.length === 0) {
        setResult(defaultValue)
        setValue(defaultValue)
      } else {
        setResult(values as EventRecurrenceDayEnum[])
      }
    }
  })

  return (
    <HStack mt="8px" data-test={dataTest}>
      {options.map((value, index) => {
        const radio = getCheckboxProps({ value })
        return (
          <DaySelectorItem key={index} {...radio}>
            {getDayShortcut(index)}
          </DaySelectorItem>
        )
      })}
    </HStack>
  )
}

const DaySelectorItem = (props) => {
  const { getInputProps, getCheckboxProps } = useCheckbox(props)
  const { theme } = useLooopTheme()

  const input = getInputProps()
  const checkbox = getCheckboxProps()

  return (
    <Box as="label">
      <input {...input} />
      <Center
        {...checkbox}
        cursor="pointer"
        border={`1px solid ${brandColors.grey[500]}`}
        borderRadius="50%"
        boxSize="38px"
        _checked={{
          bg: theme.colors.buttonPrimary.default,
          color: 'white',
          borderColor: theme.colors.buttonPrimary.default
        }}
      >
        {props.children}
      </Center>
    </Box>
  )
}
